import React from "react";
import CoursePostulation from "../course/Postulation";

const ApplicantPostulations = ({ postulations = [], isAdmin, currentUserRole }) => {
  if (!postulations || postulations.length === 0) {
    return (
      <div className="text-center text-muted py-5">
        <i className="fas fa-info-circle fa-2x mb-3 d-block" aria-hidden="true"></i>
        <p className="mb-0">Este candidato aún no ha postulado a ningún proceso.</p>
      </div>
    );
  }

  return (
    <>
      {postulations.map(p => (
        <CoursePostulation
          key={p.id}
          postulation={p}
          isAdmin={isAdmin}
          currentUserRole={currentUserRole}
        />
      ))}
    </>
  );
};

export default ApplicantPostulations;
